// src/pages/DevPreview.tsx
// TEMPORARY: unprotected UI preview for layout testing (no auth, no Firebase).
// Renders the exact QuizList / QuizSessions card markup with mock data.
// Delete this file + its /dev/preview route once layout is verified.
import { Link } from 'react-router-dom';

const mockQuizzes = [
  { id: 'q1', title: 'General Knowledge Showdown', questions: 12, sessions: 3 },
  { id: 'q2', title: 'A Really Long Quiz Title That Should Truncate Instead Of Wrapping Or Breaking The Card Layout', questions: 8, sessions: 0 },
  { id: 'q3', title: 'Movies & Music Trivia', questions: 20, sessions: 7 },
];

const mockSessions = [
  { id: '482913', status: 'in_progress', createdAt: Date.now() - 3600_000 },
  { id: '105576', status: 'not_started', createdAt: Date.now() - 86400_000 },
  { id: '730022', status: 'ended', createdAt: Date.now() - 172800_000 },
];

const getStatusBadgeClass = (status: string) => {
  switch (status) {
    case 'not_started':
      return 'bg-accent/30 text-ink';
    case 'in_progress':
      return 'bg-tile-green text-white';
    case 'ended':
      return 'bg-ink/10 text-ink/60';
    default:
      return 'bg-ink/10 text-ink/60';
  }
};

export const DevPreview = () => {
  return (
    <div className="space-y-12 py-8">
      {/* ---- QuizList preview ---- */}
      <section className="max-w-3xl mx-auto p-4 sm:p-6">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-2xl font-extrabold font-display tracking-tight">Your quizzes (preview)</h1>
          <Link to="/admin/create" className="btn-primary text-sm">+ New quiz</Link>
        </div>

        <input
          type="text"
          placeholder="Search quizzes…"
          className="w-full p-3 rounded-xl border-2 border-ink/15 focus:border-ink focus:outline-none mb-5"
        />

        <div className="space-y-3">
          {mockQuizzes.map((quiz) => (
            <div key={quiz.id} className="card p-5 flex flex-col sm:flex-row sm:items-center gap-4">
              <div className="min-w-0 flex-1">
                <h3 className="text-lg font-bold truncate">{quiz.title}</h3>
                <p className="text-sm text-slate-500">
                  {quiz.questions} questions · {quiz.sessions} sessions
                </p>
              </div>
              <div className="flex gap-2 shrink-0">
                <button className="btn-success text-sm flex-1 sm:flex-none">Host live</button>
                <Link to="#" className="btn text-sm flex-1 sm:flex-none text-ink bg-ink/10 hover:bg-ink/15">
                  Sessions
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ---- QuizSessions preview ---- */}
      <section className="max-w-4xl mx-auto p-4">
        <div className="mb-6">
          <Link to="/admin/quizzes" className="text-ink font-semibold underline decoration-2 decoration-accent underline-offset-2">
            ← Back to Quizzes
          </Link>
          <h2 className="text-2xl font-bold font-display tracking-tight mt-2">Movies &amp; Music Trivia - Sessions (preview)</h2>
        </div>

        <div className="space-y-4">
          {mockSessions.map((session) => (
            <div key={session.id} className="card p-5 flex flex-col sm:flex-row sm:items-center gap-4">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="text-lg font-bold font-display tabular-nums tracking-wider">{session.id}</h3>
                  <span className={`chip ${getStatusBadgeClass(session.status)}`}>
                    {session.status.replace('_', ' ').toUpperCase()}
                  </span>
                </div>
                <p className="text-sm text-slate-500 mt-1">
                  Created {new Date(session.createdAt).toLocaleString()}
                </p>
              </div>
              <Link to="#" className="btn-primary text-sm shrink-0">
                Manage session
              </Link>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};
